/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type Contact = {
  address: Address,
  birthday: string,
  email: string,
  phone: string,
  notificationType: Array< NotificationType >,
  paymentType: PaymentType,
  pickUp?: PickUp | null,
};

export type Address = {
  name: string,
  lastName: string,
  street: string,
  postalCode: string,
  city: string,
  country: string,
};

export enum NotificationType {
  EMAIL = "EMAIL",
  SMS = "SMS",
  WHATSAPP = "WHATSAPP",
}


export enum PaymentType {
  CASH = "CASH",
  TRANSFER = "TRANSFER",
  PAYPAL = "PAYPAL",
}


export type PickUp = {
  address?: Address | null,
  weight: number,
  date: string,
  timespan: string,
};

export type Disposal = {
  type: DisposalType,
  materials?: Array< Material > | null,
  brand?: string | null,
  model?: string | null,
  referenceNumber?: string | null,
  comments?: string | null,
  image?: Image | null,
};

export enum DisposalType {
  WATCH = "WATCH",
  DENTAL_GOLD = "DENTAL_GOLD",
  DIAMOND = "DIAMOND",
  JEWELLERY = "JEWELLERY",
  COIN_BAR = "COIN_BAR",
}


export enum Material {
  GOLD = "GOLD",
  SILVER = "SILVER",
  PLATIN = "PLATIN",
  PALLADIUM = "PALLADIUM",
  FASHION = "FASHION",
  UNKNOWN_DIFFERENT = "UNKNOWN_DIFFERENT",
}


export type Image = {
  fileName: string,
  url: string,
  data: string,
};

export type SendMailQueryVariables = {
  contact?: Contact | null,
  disposals?: Array< Disposal | null > | null,
};

export type SendMailQuery = {
  sendMail?: string | null,
};
